import { render } from "./Notes11.vue?vue&type=template&id=1383e531&scoped=true"
import script from "./Notes11.vue?vue&type=script&lang=js"
export * from "./Notes11.vue?vue&type=script&lang=js"

import "./Notes11.vue?vue&type=style&index=0&id=1383e531&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1383e531"]])

export default __exports__